import React from 'react';
import icon from '../../images/icons/phonepe.svg';

const PhonePe = () => <img src={icon} alt="Phonepe" loading="lazy" />;

export default PhonePe;
